import { render, staticRenderFns } from "./accountDetail.vue?vue&type=template&id=1585f041&"
import script from "./accountDetail.vue?vue&type=script&lang=js&"
export * from "./accountDetail.vue?vue&type=script&lang=js&"
import style0 from "./accountDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports